import { render, staticRenderFns } from "./pconnectlinequestion.vue?vue&type=template&id=2cba6f3e&scoped=true&"
import script from "./pconnectlinequestion.vue?vue&type=script&lang=js&"
export * from "./pconnectlinequestion.vue?vue&type=script&lang=js&"
import style0 from "./pconnectlinequestion.vue?vue&type=style&index=0&id=2cba6f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba6f3e",
  null
  
)

export default component.exports